// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gWOg35AOml3Ztu {
  position: relative;
  min-width: 375px;
  max-width: 600px;
  border-radius: var(--ds-radius-large, 8px);
  background-color: var(--ds-surface, #ffffff);
}
.gWOg35AOml3Ztu .u3d8X_VVxM4Mdt {
  width: 100%;
  border-radius: var(--ds-radius-large, 8px);
}
.gWOg35AOml3Ztu .X1IUX6_LKvuY_s {
  border-radius: 0;
}
.gWOg35AOml3Ztu .VrDpcBQpuCLJ_l {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--ds-space-400, 32px);
  text-align: center;
}
.gWOg35AOml3Ztu .VrDpcBQpuCLJ_l .dAZIlB2RH7A3y3 {
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0);
  font-size: 24px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 28px;
}
.gWOg35AOml3Ztu .VrDpcBQpuCLJ_l .vQHYDcjkAoKwRi,
.gWOg35AOml3Ztu .VrDpcBQpuCLJ_l .bFfTqT_1dvcai9 {
  border: 0;
  font-size: 14px;
  line-height: 20px;
}
.gWOg35AOml3Ztu .VrDpcBQpuCLJ_l .bFfTqT_1dvcai9 {
  margin-top: var(--ds-space-200, 16px);
  padding: var(--ds-space-0, 0);
  background-color: transparent;
  color: var(--ds-link, #0c66e4);
  text-decoration: none;
}
.gWOg35AOml3Ztu .VrDpcBQpuCLJ_l .ijhoKVhvs6ekzi {
  margin-top: var(--ds-space-400, 32px);
}
`, ""]);
// Exports
export var PremiumTrialModal = `gWOg35AOml3Ztu`;
export var image = `u3d8X_VVxM4Mdt`;
export var gaImage = `X1IUX6_LKvuY_s`;
export var contentContainer = `VrDpcBQpuCLJ_l`;
export var title = `dAZIlB2RH7A3y3`;
export var description = `vQHYDcjkAoKwRi`;
export var trialExtension = `bFfTqT_1dvcai9`;
export var ctaButton = `ijhoKVhvs6ekzi`;
export default ___CSS_LOADER_EXPORT___;
